import { create } from "zustand";
import { persist } from "zustand/middleware";
import { FONT_SIZE_ACTION, FONT_SIZE_LEVELS } from "../helpers/constant";

export const useThemeStore = create(
    persist(
        (set) => ({
            currentTheme: "",
            setCurrentTheme: (currentTheme) => set({ currentTheme }),

            fontSizeLevel: FONT_SIZE_LEVELS.NORMAL,
            setFontSizeLevel: (type) => set((prev) => {
                let value = FONT_SIZE_LEVELS.NORMAL;
                switch (type) {
                    case FONT_SIZE_ACTION.INCREASE:
                        value = Math.min((prev.fontSizeLevel || 0) + FONT_SIZE_LEVELS.STEP, FONT_SIZE_LEVELS.MAX)
                        break;
                    case FONT_SIZE_ACTION.DECREASE:
                        value = Math.max((prev.fontSizeLevel || 0) - FONT_SIZE_LEVELS.STEP, FONT_SIZE_LEVELS.MIN)
                        break;
                    default:
                        value = FONT_SIZE_LEVELS.NORMAL
                        break;
                }
                return { fontSizeLevel: value }
            })
        }),
        {
            name: 'theme-store',
        }
    )
);
